import {API} from 'aws-amplify';
import axios from 'axios';

export const read = async () => {
  const result = await API.get('ihrespezialistenBackend', '/sibinfo', {});
  return result.data;
};

export const generate = async (articles: any) =>
  API.post('ihrespezialistenBackend', `/newsletter/generate`, {body: articles});

// export const resendConfirmation = async (data: any) =>
//   API.post('ihrespezialistenBackend', `/newsletter/resendConfirmation`, {body: {...data}});
//
export const updateRecipient = async (data: any) => {
  const result = await API.post('ihrespezialistenBackend', '/sibinfo', {body: data});
  return result.data;


  // const result = await myApi.post('subscribers/update_subscriber_custom_fields.php', querystring.stringify({
  //   api_key: 'Ax1exQ4SnVQsv6A1xmkQ',
  //   list_id: '7BtZA3Ab4OFjeEv763XbdMOQ',
  //   list: data.list,
  //   userID: data.userID,
  //   id: data.id,
  //   custom_fields: data.custom_fields,
  // }));
  //
  // return result.data;
};
